import { schema } from "normalizr";

export const user = new schema.Entity(
  "users",
  {},
  { idAttribute: "user_id" }
);
